
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pam/jit-access",
      function () {
        return require("private-next-pages/pam/jit-access.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pam/jit-access"])
      });
    }
  